<lm-html-url-doc #LMHtmlUrlDoc
    [isHtmlFragment]="true"
    [url]="url"
    (contentModified)="onContentModified($event)"
    >
</lm-html-url-doc>


